import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { FiArrowLeft } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import JoinByCodeForm from '../components/groups/JoinByCodeForm';

function JoinGroup({ onJoinGroup }) {
  const navigate = useNavigate();

  const handleSuccess = async (group) => {
    if (onJoinGroup) await onJoinGroup();
    // Redirect to the joined group's details page
    setTimeout(() => {
      navigate(`/group/${group.invite_code || group.id}`);
    }, 300);
  };

  return (
    <div className="min-h-screen bg-app">
      <Helmet>
        <title>Join Group - TeeSync</title>
      </Helmet>
      <div className="max-w-lg mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <button
            onClick={() => navigate('/')}
            className="flex items-center text-text-secondary hover:text-text-primary mb-6 group transition-colors"
          >
            <SafeIcon
              icon={FiArrowLeft}
              className="w-4 h-4 mr-2 group-hover:-translate-x-0.5 transition-transform"
            />
            <span className="text-sm font-medium">Back to Dashboard</span>
          </button>

          <h1 className="text-2xl font-bold text-text-primary mb-1">Join a Group</h1>
          <p className="text-sm text-text-secondary mb-6">
            Enter an invite code to join an existing golf group.
          </p>

          <div className="bg-surface rounded-lg border border-border-subtle shadow-card p-5">
            <JoinByCodeForm
              onSuccess={handleSuccess}
              onCancel={() => navigate('/')}
              submitLabel="Preview Group"
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default JoinGroup;
